import React, { useState, useEffect, useRef } from 'react';
import { Link, Navigate } from "react-router-dom";
import { useMemo } from 'react';

import { useParams } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel3';
import ReactImageZoom from 'react-image-zoom';
import { Dropdown, Button, Row, Col, Accordion } from 'react-bootstrap';

import Header from '../layout/Header';
import Footer from '../layout/Footer';
import CommanList from '../view/Component/CommanList';

import apiPath from "../constants/apiPath";
import Http from "../services/Http";
import { CART_DRAWER_UPDATED } from "../services/cartDrawerEvents";

import toast, { Toaster } from 'react-hot-toast';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


import ImgPerfume1 from '../assets/img/perfume-1.jpg';
import ImgShare from '../assets/img/share.png';
import ImgmStar from '../assets/img/star.png';
import ImgmStar1 from '../assets/img/star-1.png';

import ImgProductTranding from '../assets/img/product-trending.png';

import ImgGucciLogo from '../assets/img/gucci_logo.png';
import ImgCheckout1 from '../assets/img/checkout-1.png';
import ImgCheckout3 from '../assets/img/checkout-3.png';

import ImgmFacebook from '../assets/img/facebook.png';
import ImgmTwitter from '../assets/img/twitter.png';
import ImgWhatup from '../assets/img/whatup.png';
import noReview from '../assets/img/no-review.png';


import { userLogin } from "../actions/index";
import { connect } from "react-redux";
import moment from 'moment';
import ProgressBar from './Component/progress-bar.component';
import Product from './Component/Product';
import Currency from './Component/Currency';
import BnplWidget from './BnplWidget';

import LocalizedStrings from "react-localization";
import localization from "../localization";
import useScript from '../constants/useScript';

import Modal from 'react-bootstrap/Modal';
import Imgcross from '../assets/img/cross.png';
import { Form } from 'react-bootstrap';
import { TextInput, SelectGroup, ValidationForm } from "react-bootstrap4-form-validation";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { Rating } from 'react-simple-star-rating';
import { Helmet } from 'react-helmet';

let strings = new LocalizedStrings(localization);

const useCountdown = (targetDate) => {
   const [timeLeft, setTimeLeft] = useState({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
   });

   useEffect(() => {
      if (!targetDate) return;

      const interval = setInterval(() => {
         const now = new Date().getTime();
         const distance = targetDate - now;

         if (distance <= 0) {
            clearInterval(interval);
            setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
         } else {
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((distance / (1000 * 60)) % 60);
            const seconds = Math.floor((distance / 1000) % 60);

            setTimeLeft({ days, hours, minutes, seconds });
         }
      }, 1000);

      return () => clearInterval(interval);
   }, [targetDate]);

   return timeLeft;
};


const mapStateToProps = state => {
   return { user: state.user };
};

const mapDispatchToProps = dispatch => {
   return {
      userLogin: user => dispatch(userLogin(user))
   };
}


const newAriveOption = {
   margin: 15,
   nav: true,
   dots: false,
   loop: false,
   responsive: {
      0: {
         items: 2,
         margin: 7.5
      },
      420: {
         items: 2,
         margin: 7.5
      },
      577: {
         items: 3,
         margin: 7.5
      },
      767.98: {
         items: 4
      },
      992: {
         items: 5
      },
      1366: {
         items: 6
      },
      1480: {
         items: 6
      },
      1580: {
         items: 7
      }
   }
}


const testData = [
   { bgcolor: "#6a1b9a", completed: 60 },
   { bgcolor: "#00695c", completed: 30 },
   { bgcolor: "#ef6c00", completed: 53 },
];

const ProductDetail = (Props) => {
   const [isScriptLoaded, setScriptLoaded] = useState(false);

   const [nameReview, setNameReview] = useState('');
   const [phoneReview, setPhoneReview] = useState('');

   const formRef = React.createRef();
   const formRef2 = React.createRef();
   const [flyItem, setFlyItem] = useState(null);
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const [modalNotifyMeIsOpen, setModalNotifyMeIsOpen] = useState(false);
   const [setting, setSetting] = useState([]);

   const setModalIsOpenToTrue = (item, attributes) => {
      const firstAttrValues = attributes[0]?.attribute_values || [];
		const firstAttrValue = firstAttrValues[0];

		setCommanList(prev => ({
			...prev,
			product_id: item.id,
			attributes: attributes,
			product: item,
			attribute_value_id: firstAttrValue?.id || null
		}), () => {
			if (firstAttrValues.length > 1 && firstAttrValue?.id) {
				handleAttributeChange(item.id, firstAttrValue.id);
			}
		});
      setModalIsOpen(true)
   }

   const setModalIsOpenToFalse = () => {
      setModalIsOpen(false)
   }

   const showModalNotifyMe = (e) => {
      e.preventDefault();
      setModalNotifyMeIsOpen(true);
   }

   const setModalNotifyMeIsOpenToFalse = () => {
      setModalNotifyMeIsOpen(false);
      // console.log(modalNotifyMeIsOpen);
   }

   const showAddtoCart = async (e, item, attributes) => {
      e.preventDefault();
      if (attributes.length > 0) {
         setModalIsOpenToTrue(item, attributes);
      }
      else {
         setCommanList({ ...commanList, product_id: item.id, attribute_value_id: null, product: item });
         addtoCartList(item.id, null);
      }
   };

   const getSetting = async () => {
		let path = apiPath.setting;
		var data = new FormData();
		let options = {
			method: "GET",
		};
		let result = await Http(path, options);
		if (result.status == 200) {
			if (result.data.status == true) {
				setSetting({ data: result.data.data });
			} else {
				toast.error(result.data.message);
			}
		} else {
			if(result.statusText != null) {
				toast.error(result?.data?.message || result.statusText);
			}
		}
	};

   const handleAttributeChange = async (productId, attributeValueId) => {
		try {
			let path = apiPath.ProductAvailability + '/' + productId;
			var data = new FormData();
			data.append('attribute_value_id', attributeValueId);
			let options = {
				method: 'POST',
				data: data
			}
			let result = await Http(path, options);
			if (result.status == 200) {
				if (result.data.status) {
               setCommanList(prev => ({
						...prev,
						product: {
							...prev.product,
							discount_price: result.data.data.product.discount_price,
							original_price: result.data.data.product.original_price
						}
					}));
				}
				else {
					toast.error(result.data.message);
				}
			}
		} catch (error) {
		  console.error('Error updating price:', error);
		  toast.error('An error occurred while updating price');
		}
	};

   const addtoCartList = async (id, type) => {
      let path = apiPath.AddtoCart;
      var data = new FormData();
      data.append('product_id', id);
      data.append('qty', 1);
      data.append('is_increment', 1);
      if (type == null && commanList.attribute_value_id != null) {
         data.append('product_attribute_values_id', commanList.attribute_value_id);
      }
      else if (type == 'form') {
         const attributeValueId = document.querySelector('input[name="attribute_value_id"]:checked');
         if (attributeValueId != null && attributeValueId != "") {
               data.append('product_attribute_values_id', attributeValueId.value);
         }
      }

      if (selectedVariant && selectedVariant.id) {
         data.append('variant_image_id', selectedVariant.id);
      }

      let options = {
         method: 'POST',
         data: data
      }

      let result = await Http(path, options);
      if (result.status == 200) {
         if (result.data.status) {
            setComman({ ...comman, addCart: true });
            toast.success(result.data.message);
         }
         else {
            toast.error(result.data.message);
         }
         setModalIsOpenToFalse();
      }
   }

   const params = useParams()


   const [user, setUser] = useState(Object.keys(Props.user).length > 0 ? Props.user : null)

   const [commanList, setCommanList] = useStateWithCallbackLazy({
      product_id: 0,
      attributes: [],
      attribute_value_id: null,
      product: null
   });

   const [comman, setComman] = useState({
      zoomWidth: 500,
      img: ImgPerfume1,
      qty: 1,
      addCart: false,
      buyNow: false,

   });
   const [productDetails, setProductDetails] = useState([]);
   const [productRating, setProductRating] = useState([]);
   const [attr, setAttr] = useState([]);

   const saleTime = productDetails?.data?.product?.sale_time;
   const hasSale = (productDetails?.data?.product?.sale_time != null && productDetails?.data?.product?.sale_time > 0);

   const countdownTarget = useMemo(() => {
      if (!saleTime || saleTime <= 0) return null;
      return new Date().getTime() + saleTime * 60000;
   }, [saleTime]);

   const { days, hours, minutes, seconds } = useCountdown(countdownTarget);

   const [currentLang, setCurrentLang] = useState(
      localStorage.getItem("current_lang")
         ? localStorage.getItem("current_lang")
         : "en"
   );
   strings.setLanguage(currentLang);

   function isNumber(n) {
      return !isNaN(parseFloat(n)) && !isNaN(n - 0);
   }

   const changeImag = (e, item) => {
      setComman({ ...comman, img: item.image });
   }

   const current_currency = localStorage.getItem('current_currency') ? JSON.parse(localStorage.getItem('current_currency')) : { currency: 1, country_code: 'KWD' };

   const getProductDetails = async (id, type) => {
      var path;
      if (isNumber(id)) {
         path = apiPath.productDetails + '/' + id + type;
      }
      else {
         path = apiPath.productDetailsWeb + '/' + id + type;
      }

      var data = new FormData();
      let options = {
         method: 'GET',
      }
      let result = await Http(path, options);
      if (result.status == 200) {
         if (result.data.status) {
            await setProductDetails({ data: result.data.data })

            if (result.data.data.product.attribute_value_id != null) {
               setAttr(result.data.data.product.attribute_value_id.toString());
            }
            else {
               setAttr("");
            }

            // If the slug resolved to an out-of-stock variant but another size
            // is still available, auto-select the first in-stock size so the
            // detail page doesn't land on "Out of stock" (mirrors the in-stock
            // default already used on product listings).
            try {
               const prod = result.data.data.product;
               const attrs = result.data.data.attributes || [];
               const prodOOS = prod && (prod.out_of_stock == 1 || prod.status == 0 || prod.left <= 0);
               // Only the single-attribute (size) case: multi-attribute variants
               // need a full combination, so don't guess there.
               if (prodOOS && attrs.length === 1) {
                  const values = attrs[0].attribute_values || [];
                  const current = values.find(v => v.id === prod.attribute_value_id);
                  const currentInStock = current && current.left > 0;
                  const inStock = values.find(v => v.left > 0);
                  if (!currentInStock && inStock && inStock.id !== prod.attribute_value_id) {
                     const apath = apiPath.ProductAvailability + '/' + id;
                     const adata = new FormData();
                     adata.append('attribute_value_id', inStock.id.toString());
                     const ares = await Http(apath, { method: 'POST', data: adata });
                     if (ares.status == 200 && ares.data.status) {
                        setProductDetails({ data: ares.data.data });
                        setAttr(inStock.id.toString());
                        setComman(c => ({ ...c, img: ares.data.data.product.image }));
                     }
                  }
               }
            } catch (e) {
               // Non-fatal: on any error keep the default variant as-is.
            }

            if (result.data.data.cart_item != 0) {
               setComman({ ...comman, qty: parseInt(result.data.data.cart_item), img: result.data.data.product.image });
            }
            else {
               setComman({ ...comman, img: result.data.data.product.image });
            }

            // getRatingData(productDetails)
            let price = result.data.data.product_sale ? (result.data.data.product_sale.discount_price != 0 ? result.data.data.product_sale.discount_price : result.data.data.product_sale.original_price) : (result.data.data.product.discount_price != 0 ? result.data.data.product.discount_price : result.data.data.product.original_price);

            if (isScriptLoaded) {
               new window.TabbyPromo({
                  selector: '#tabbyCard',
                  lang: localStorage.getItem("current_lang") ? localStorage.getItem("current_lang") : "en",
                  currency: current_currency.country_code,
                  price: ((parseFloat(current_currency.currency) * price).toFixed(2)),
                  productType: 'installments',
               });
            }
         }
         else {
            toast.error(result.data.message);
         }
      }
   }

   const orderSample = async (id) => {
      let path = apiPath.AddtoCart;
      var data = new FormData();
      data.append('product_id', id);
      data.append('qty', 1);
      data.append('is_increment', 1);
      data.append('is_sample', true);

      let options = {
         method: 'POST',
         data: data
      }

      let result = await Http(path, options);
      if (result.status == 200) {
         if (result.data.status) {
            setComman({ ...comman, addCart: true });
            toast.success(result.data.message);
         } else {
            toast.error(result.data.message);
         }
         setModalIsOpenToFalse();
         setSampleOrdered(true);
      }
   }

   const [sampleOrdered, setSampleOrdered] = useState(false);

   const productShare = (e, id, title, type) => {
      const url = window.location.href;
      const text = title || '';
      if (type == 'facebook') {
         window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank');
      } else if (type == 'twitter') {
         window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(text), '_blank');
      } else if (type == 'whatup') {
         window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), '_blank');
      } else if (type == 'telegram') {
         window.open('https://t.me/share/url?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(text), '_blank');
      } else if (type == 'copy') {
         try {
            navigator.clipboard.writeText(url);
            toast.success(strings.copied || 'Link copied');
         } catch (err) { }
      }
   }

   const chnageattributeValue = async (e, i) => {
      var attribute = attr.split(",");

      var old_attribute = attribute;

      attribute.map((item, index) => {
         if (i == index) {
            attribute[index] = parseInt(e.target.value)
         }
         else {
            attribute[index] = parseInt(item)
         }

      });


      let path = apiPath.ProductAvailability + '/' + params.id;
      var data = new FormData();
      data.append('attribute_value_id', attribute.toString());
      let options = {
         method: 'POST',
         data: data
      }
      let result = await Http(path, options);
      if (result.status == 200) {
         if (result.data.status) {
            setProductDetails({ data: result.data.data })
            setComman({ ...comman, img: result.data.data.product.image });
            setAttr(attribute.toString());
         }
         else {
            toast.error(result.data.message);
         }
      }
   }

   const getRatingReview = async (id) => {

      let path = apiPath.productRatingList;
      var data = new FormData();
      data.append('product_id', id)
      let options = {
         method: 'POST',
         data: data
      }
      let result = await Http(path, options);
      if (result.status == 200) {
         if (result.data.status) {

            setProductRating({ data: result.data.data })
            //   alert(productRating.data.length)
            //   setComman({ ...comman, img:result.data.data.product.image}); 
            //   setAttr(result.data.data.product.attribute_value_id);
            if (window.location.hash === '#reviews') {
               handleScrollToRatingBlock();
            }
         }
         else {
            // toast.error(result.data.message);
         }
      }
   }

   const likeReview = async (review_id, type) => {

      let path = apiPath.likeReview;
      var data = new FormData();
      data.append('review_id', review_id);
      data.append('type', type);
      let options = {
         method: 'POST',
         data: data
      }

      let result = await Http(path, options);
      if (result.status == 200) {
         if (result.data.status) {
            getRatingReview(params.id)
         }
         else {
            toast.error(result.data.message);
         }
      }
   }


   const addRemove = (e, type) => {
      var qty = 0;
      if (type == 'add') {
         if (productDetails.data.product.left > comman.qty) {
            qty = comman.qty + 1;
         }
         else {
            qty = comman.qty;
         }

      }
      else {
         if (comman.qty > 1) {
            qty = comman.qty - 1;
         }
      }
      let price = productDetails.data.product_sale ? (productDetails.data.product_sale.discount_price != 0 ? productDetails.data.product_sale.discount_price : productDetails.data.product_sale.original_price) : (productDetails.data.product.discount_price != 0 ? productDetails.data.product.discount_price : productDetails.data.product.original_price);

      if (isScriptLoaded) {
         new window.TabbyPromo({
            selector: '#tabbyCard',
            lang: localStorage.getItem("current_lang") ? localStorage.getItem("current_lang") : "en",
            currency: current_currency.country_code,
            price: ((parseFloat(current_currency.currency) * price * qty).toFixed(2)),
            productType: 'installments',
         });
      }
      setComman({ ...comman, qty: qty });
   }

   const addtoCart = async (type) => {

      if (comman.qty > 0) {
         let path = apiPath.AddtoCart;
         var data = new FormData();
         data.append('product_id', productDetails.data.product.id);
         if (params.type != undefined) {
            data.append('is_sale', params.type);
         }
         data.append('qty', comman.qty);
         if (attr) {
            data.append('product_attribute_values_id', attr);
         }

         if (selectedVariant && selectedVariant.id) {
            data.append('variant_image_id', selectedVariant.id);
         }

         let options = {
            method: 'POST',
            data: data,
            skipCartDrawer: type == 'BuyNow'
         }
         let result = await Http(path, options);
         if (result.status == 200) {
            if (result.data.status) {

               if (type == 'BuyNow') {
                  setComman({ ...comman, buyNow: true });
               }
               else {
                  setComman({ ...comman, addCart: true });
               }
               // getProductDetails(params.id);
               toast.success(result.data.message);
            }
            else {
               toast.error(result.data.message);
            }
         }
      }
      else {
         toast.error(strings.at_last_one_qty);
      }
   }

   const triggerFlyToCart = () => {
      const cartEl = document.getElementById('cart');
      const imgEl = document.querySelector('.zoom_sld_main img');
      if (!cartEl || !imgEl) return;
      const from = imgEl.getBoundingClientRect();
      const to = cartEl.getBoundingClientRect();
      setFlyItem({
         key: Date.now(),
         src: imgEl.src,
         style: {
            left: from.left + from.width / 2 - 30,
            top: from.top + from.height / 2 - 30,
            '--dx': `${to.left + to.width / 2 - (from.left + from.width / 2)}px`,
            '--dy': `${to.top + to.height / 2 - (from.top + from.height / 2)}px`,
         },
      });
      setTimeout(() => setFlyItem(null), 900);
   };

   const getRatingData = async (data) => {

   }

   const notifyMe = async () => {
      let path = apiPath.notifyMe + '/' + params.id;
      var data = new FormData();
      console.log(nameReview, phoneReview);
      data.append('name', nameReview);
      data.append('phone', phoneReview);
      let options = {
         method: 'POST',
         data: data
      }
      let result = await Http(path, options);
      if (result.status == 200) {
         if (result.data.status) {
            toast.success(result.data.message);
         }
         else {
            toast.error(result.data.message);
         }
      }
      setModalNotifyMeIsOpen(false);
   }

   const handleScrollToRatingBlock = () => {
      const targetElement = document.getElementById('perfumeBlockFirst');
      if (targetElement) {
         window.scrollTo({
            top: targetElement.offsetTop - 150,
            behavior: 'smooth',
         });

         window.history.pushState({}, '', '#reviews');
      }
   };

   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://checkout.tabby.ai/tabby-promo.js';
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
         setScriptLoaded(true);
      };

      getSetting();

      return () => {
         document.body.removeChild(script);
      };
   }, []);

   useEffect(() => {
      if (isScriptLoaded) {
         if (window.location.hash !== '#reviews') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
         }

         getProductDetails(params.id, params.type ? '/' + params.type : '');
         getRatingReview(params.id)
      }
   }, [params, isScriptLoaded]);

   useEffect(() => {
      const handleCartUpdated = () => {
         getProductDetails(params.id, params.type ? '/' + params.type : '');
      };

      window.addEventListener(CART_DRAWER_UPDATED, handleCartUpdated);

      return () => {
         window.removeEventListener(CART_DRAWER_UPDATED, handleCartUpdated);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [params]);

   const selectedAttrValueId = productDetails?.data?.product?.attribute_value_id;

   const attributes = productDetails?.data?.product?.attributes ? productDetails.data.product.attributes[0] : null;

   const selectedAttributeValue = attributes ? attributes.attribute_values.find(attr_val => attr_val.id == selectedAttrValueId) : null;

   const selectedProductImages = (selectedAttributeValue && Array.isArray(selectedAttributeValue?.product_images)) ? selectedAttributeValue.product_images : [];

   const [selectedVariant, setSelectedVariant] = useState({});

   const productImages = Array.isArray(productDetails?.data?.product?.product_images) ? productDetails.data.product.product_images : [];

   const combinedImages = [...productImages, ...selectedProductImages];

   const [activeSlideshowImage, setActiveSlideshowImage] = useState(combinedImages[0]?.image || '');

   const handleSelectVariantImage = async (variant_id, imgIdx, imageId, image) => {
      // Update the selected variant
      setSelectedVariant({
         variant_id,
         imgIdx,
         id: imageId,
         image
      });

      // Set the active slideshow image
      setActiveSlideshowImage(image);

      setComman({ ...comman, img: image });
   };

   return (
      <>
         {comman.buyNow ? <Navigate to="/cart" replace={true} /> : ''}
         <Helmet>
            <title>{productDetails.data && productDetails.data.meta_title != "" ? productDetails.data.meta_title : "The perfumesmell"}</title>
            <meta name="description" content={productDetails.data && productDetails.data.meta_description != "" ? productDetails.data.meta_description : "The perfumesmell"} />
            <meta name="keywords" content={productDetails.data && productDetails.data.meta_keywords != "" ? productDetails.data.meta_keywords : "The perfumesmell"} />
            <meta name="robots" content="index, follow" />
            {/* Canonical = the URL slug being viewed (the parent product), NOT the
                default variant's slug (product.slug resolves to e.g. ...-100ml).
                Keeps one stable canonical per product regardless of the selected
                size, matching the prerender which 301s child-variant URLs to this. */}
            <link rel="canonical" href={`https://www.theperfumesmell.com/product-detail/${params.id || productDetails?.data?.product?.slug || productDetails?.data?.product?.id}`} />
         </Helmet>
         <Header data={comman.addCart} />
         <main className='prd_detail_space'>
            <section className="cart-page mobile-button">
               <div className="container">
                  <div className="cart_row">
                     <div className="cart_left">
                        <div className="cart_title try_sample_title">
                        {setting.data && setting.data.special_menu_enable ? (
                              <Link to="/special-sale" className="nav-link special-sale-btn">
                                 <span className="header_badge">
                                    {setting.data.special_menu_text}
                                 </span>
                              </Link>
                           ) : (
                              <Link to="/try-samples" className="nav-link">
                                 <span className="try_samples_badge">
                                    {strings.trySamples}
                                 </span>
                              </Link>
                           )}
                        </div>
                     </div>
                  </div>
               </div>
            </section>
            {productDetails.data ?
               <>
                  <section className="space-cls product_dtl_page">
                     <div className="container">
                        <div className="row">
                           <div className="col-md-12 col-lg-4 pdp-gallery-col">
                              <div className="product-slide-main">
                                 <div id='lens'></div>

                                 <div className='zoom_sld_main' style={{ 'position': "relative", 'zIndex': '1' }}>
                                    <ReactImageZoom {...comman} />
                                 </div>
                                 <div id='result'></div>


                                 <OwlCarousel className="owl-carousel owl-theme" {...newAriveOption} key={combinedImages.length}>
                                    {combinedImages.length > 0 ? 
                                       combinedImages.map((item, index) => 
                                          <div className="item" key={index}
                                             onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                changeImag(e, item);
                                             }}
                                          >
                                             <img 
                                                className={`slideshow-thumbnails ${activeSlideshowImage === item.image ? 'active' : ''}`}
                                                src={item.image}
                                                alt={item.name} 
                                             />
                                          </div>
                                       ) : ''}
                                 </OwlCarousel>
                              </div>
                              {productDetails?.data?.product?.more_inspired_by?.length > 0 && (
  <>
    <div className="more-inspired-by d-none d-md-block" style={{ marginTop: 16 }}>
      <h5
        className="heading-type2"
        style={{ marginBottom: 10, color: 'black', textAlign: 'center' }}
      >
        {strings.more_inspired_by}
      </h5>

      <div
        className="more-inspired-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))',
          gap: 12,
          alignItems: 'stretch',
        }}
      >
        {productDetails.data.product.more_inspired_by.map((p) => (
          <Link
            key={p.id}
            to={`/product-detail/${p.slug}`}
            className="more-inspired-item"
            title={p.name}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div
              style={{
                width: '100%',
                aspectRatio: '1 / 1',
                borderRadius: 8,
                overflow: 'hidden',
                boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
                marginBottom: 6,
              }}
            >
              <img
                src={p.image}
                alt={p.name}
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </div>
            <div
              style={{
                fontSize: 12,
                textAlign: 'center',
                lineHeight: 1.3,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {p.name}
            </div>
          </Link>
        ))}
      </div>
    </div>

    {/* Mobile: accordion (đóng mặc định) */}
    <div className="d-md-none" style={{ marginTop: 16 }}>
      <Accordion alwaysOpen={false}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>{strings.more_inspired_by}</Accordion.Header>
          <Accordion.Body>
            <div
              className="more-inspired-grid"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: 10,
                alignItems: 'stretch',
              }}
            >
              {productDetails.data.product.more_inspired_by.map((p) => (
                <Link
                  key={p.id}
                  to={`/product-detail/${p.slug}`}
                  className="more-inspired-item"
                  title={p.name}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div
                    style={{
                      width: '100%',
                      aspectRatio: '1 / 1',
                      borderRadius: 8,
                      overflow: 'hidden',
                      boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
                      marginBottom: 4,
                    }}
                  >
                    <img
                      src={p.image}
                      alt={p.name}
                      loading="lazy"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      textAlign: 'center',
                      lineHeight: 1.3,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {p.name}
                  </div>
                </Link>
              ))}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  </>
)}
                           </div>
                           <div className="col-md-12 col-lg-8">
                              <div className="prd-dtl-cont">
                              <div className="pdp-center">
                              <div className="header-prd-container">
                                 <div
                                    className={`header-prd-left ${
                                       productDetails.data.product.inspired_by ? "half-width" : "full-width"
                                    }`}
                                 >
                                    <div className="prd-brand">
                                       <div className="brand-img">
                                       <Link
                                          to={
                                             "/brand/" +
                                             (productDetails.data.product.brands
                                             ? productDetails.data.product.brands.slug
                                             : "")
                                          }
                                       >
                                          <span>
                                             <img
                                             src={
                                                productDetails.data.product.brands
                                                   ? productDetails.data.product.brands.image
                                                   : ImgGucciLogo
                                             }
                                             alt={
                                                productDetails.data.product.brands
                                                   ? productDetails.data.product.brands.name
                                                   : "Brand"
                                             }
                                             />
                                          </span>
                                       </Link>
                                       </div>
                                       <h6>
                                       {productDetails.data.product.brands
                                          ? productDetails.data.product.brands.name
                                          : ""}
                                       </h6>
                                    </div>
                                    <div className="prd-title">
                                       <h1>
                                       <span>
                                          {productDetails.data.product ? productDetails.data.product.name : ""}
                                       </span>
                                       </h1>
                                       <div className="share-option pdp-share">
                                       <Dropdown>
                                          <Dropdown.Toggle id="dropdown-custom-components" className="shareBtn" aria-label="Share">
                                             <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/><line x1="15.4" y1="6.5" x2="8.6" y2="10.5"/></svg>
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu className="pdp-share-menu">
                                             <Dropdown.Item onClick={(e) => productShare(e, productDetails.data.product.id, productDetails.data.product.name, "facebook")}>
                                                <span className="sh-ic" style={{ background: "#1877F2" }}><svg width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M15.12 5.32H17V2.14A26.11 26.11 0 0 0 14.26 2c-2.72 0-4.58 1.66-4.58 4.7v2.6H6.6v3.56h3.08V22h3.68v-9.14h3.06l.46-3.56h-3.52V7.05c0-1.03.28-1.73 1.76-1.73Z"/></svg></span>
                                                <span>{strings.facebook}</span>
                                             </Dropdown.Item>
                                             <Dropdown.Item onClick={(e) => productShare(e, productDetails.data.product.id, productDetails.data.product.name, "twitter")}>
                                                <span className="sh-ic" style={{ background: "#000" }}><svg width="14" height="14" viewBox="0 0 24 24" fill="#fff"><path d="M18.9 1.15h3.68l-8.04 9.19L24 22.85h-7.41l-5.8-7.59-6.64 7.59H.46l8.6-9.83L0 1.15h7.59l5.24 6.93 6.07-6.93Zm-1.29 19.5h2.04L6.49 3.24H4.3L17.61 20.65Z"/></svg></span>
                                                <span>{strings.twitter}</span>
                                             </Dropdown.Item>
                                             <Dropdown.Item onClick={(e) => productShare(e, productDetails.data.product.id, productDetails.data.product.name, "whatup")}>
                                                <span className="sh-ic" style={{ background: "#25D366" }}><svg width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2Zm5.8 14.01c-.24.68-1.42 1.31-1.96 1.36-.5.05-.97.23-3.27-.68-2.76-1.09-4.5-3.92-4.64-4.1-.14-.18-1.1-1.47-1.1-2.8 0-1.33.7-1.98.95-2.25.24-.27.53-.34.7-.34.18 0 .35 0 .5.01.16.01.38-.06.59.45.24.59.81 2.02.88 2.17.07.14.12.31.02.5-.09.18-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.57.16.27.71 1.17 1.53 1.9 1.05.93 1.94 1.22 2.21 1.36.27.14.43.12.59-.07.16-.18.68-.79.86-1.07.18-.27.36-.23.61-.14.24.09 1.55.73 1.82.86.27.14.45.21.51.32.07.11.07.64-.17 1.32Z"/></svg></span>
                                                <span>{strings.whatus}</span>
                                             </Dropdown.Item>
                                             <Dropdown.Item onClick={(e) => productShare(e, productDetails.data.product.id, productDetails.data.product.name, "telegram")}>
                                                <span className="sh-ic" style={{ background: "#229ED9" }}><svg width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M9.78 15.6 9.6 19.4c.36 0 .52-.16.71-.34l1.7-1.63 3.53 2.58c.65.36 1.11.17 1.28-.6L21.94 4.6c.22-1.02-.37-1.42-1.01-1.18L2.5 10.56c-1 .39-.98.95-.17 1.2l4.71 1.47 10.95-6.9c.51-.34.98-.15.6.19L9.78 15.6Z"/></svg></span>
                                                <span>{strings.telegram}</span>
                                             </Dropdown.Item>
                                             <Dropdown.Item onClick={(e) => productShare(e, productDetails.data.product.id, productDetails.data.product.name, "copy")}>
                                                <span className="sh-ic" style={{ background: "#6b6b6b" }}><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.6 13.4a4 4 0 0 0 5.66 0l2.83-2.83a4 4 0 1 0-5.66-5.66l-1.41 1.41"/><path d="M13.4 10.6a4 4 0 0 0-5.66 0L4.9 13.4a4 4 0 1 0 5.66 5.66l1.41-1.41"/></svg></span>
                                                <span>{strings.copyLink}</span>
                                             </Dropdown.Item>
                                          </Dropdown.Menu>
                                       </Dropdown>
                                       </div>
                                    </div>
                                 </div>
                                 </div>
                                 <div className="prd-info pdp-detail-block">
                                    <div className="pdp-meta">
                                       {productDetails.data.product.perfume_type ?
                                          <Link to={"/perfume-type/" + productDetails.data.product.perfume_type.slug} className="pdp-bestseller">
                                             <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.787 1.401 8.169L12 18.896l-7.335 3.86 1.401-8.169L.132 9.21l8.2-1.192z"/></svg>
                                             {strings.bestseller || 'Bestseller'} <b>{productDetails.data.product.perfume_type.name}</b>
                                          </Link> : null}
                                       {productDetails.data.product.brands ?
                                          <Link to={"/brand/" + productDetails.data.product.brands.slug} className="pdp-chip">{productDetails.data.product.brands.name}</Link> : null}
                                       {productDetails.data.product.categories ?
                                          <span className="pdp-chip">{productDetails.data.product.categories.name}</span> : null}
                                    </div>
                                    <div className="prd-info-cont">
                                       <h5>{strings.description}</h5>
                                       <p>{productDetails.data.product.description}</p>
                                    </div>
                                    {productDetails.data.product.inspired_by && (
                                       <div className="pdp-inspired header-prd-right">
                                          <Link to={"/product-detail/" + productDetails.data.product.inspired_by.slug} className="product-card-custom">
                                             <div className="product-card-container-custom">
                                                <h5 className="pdp-inspired-label">
                                                   <svg className="pdp-shine-ic" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z"/></svg>
                                                   <span className="pdp-shine-text">{strings.inspired_by}</span>
                                                </h5>
                                                <div className='inspired-by-container'>
                                                   <div className="product-image-custom">
                                                      <img src={productDetails.data.product.inspired_by.image} alt={productDetails.data.product.inspired_by.name} />
                                                   </div>
                                                   <div className="brand-logo-custom">
                                                      <img src={productDetails.data.product.inspired_by.brands.logo} alt={productDetails.data.product.inspired_by.brands.name} />
                                                   </div>
                                                </div>
                                                <div className="product-details-custom">
                                                   <h3 className="product-title-custom">{productDetails.data.product.inspired_by.name}</h3>
                                                   <div className="rating-custom">
                                                   {productDetails.data.product.inspired_by.rating > 0 && (
                                                      <div className="prd-review">
                                                         <Rating allowHover={false} allowFraction={true} initialValue={productDetails.data.product.inspired_by.rating} readonly={true} />
                                                         <span className="slash">|</span>
                                                         <span>{productDetails.data.product.inspired_by.total_rating_count} {strings.ratings}</span>
                                                      </div>
                                                   )}
                                                   </div>
                                                   {productDetails.data.product.inspired_by.discount_price > 0 ? (
                                                      <div className="price-custom">
                                                         <span className="current-price-custom">{productDetails.data.product.inspired_by.currency} {productDetails.data.product.inspired_by.discount_price}</span>
                                                         <span className="original-price-custom">{productDetails.data.product.inspired_by.currency} {productDetails.data.product.inspired_by.original_price}</span>
                                                      </div>
                                                   ) : (
                                                      <div className="price-custom">
                                                         <span className="current-price-custom">{productDetails.data.product.inspired_by.currency} {productDetails.data.product.inspired_by.original_price}</span>
                                                      </div>
                                                   )}
                                                </div>
                                             </div>
                                          </Link>
                                       </div>
                                    )}
                                 </div>
                                 </div>
                                 <div className="prd-cont-sec">
                                    <div className="main-prd-left">
                                       <div className="product-inner-dtl">
                                          <ul style={{ marginBottom: "0" }}>
                                             {productDetails.data && productDetails.data.product.trending_product ?
                                                <li>
                                                   <span className="trending-badge">
                                                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="3 17 9 11 13 15 21 7"/><polyline points="15 7 21 7 21 13"/></svg>
                                                      {strings.trending || 'Trending'}
                                                   </span>
                                                </li>
                                                : ''}
                                          </ul>
                                       </div>
                                       <div className="prd-price-wrap pdp-price-rating-row">
                                          <div className="arrival-price">
                                             <p className="hero-price">
                                                <span className="cur">{current_currency.country_code}</span>
                                                <span className="amt">{(parseFloat(current_currency.currency) * (productDetails.data.product_sale ? (productDetails.data.product_sale.discount_price != 0 ? productDetails.data.product_sale.discount_price : productDetails.data.product_sale.original_price) : (productDetails.data.product.discount_price != 0 ? productDetails.data.product.discount_price : productDetails.data.product.original_price))).toFixed(3)}</span>
                                             </p>
                                             {productDetails.data.product_sale ? parseInt(productDetails.data.product_sale.discount_price) == 0 ? '' : <p className="discount-price"><span><Currency data={productDetails.data.product_sale.original_price} /></span> ({Math.round(((productDetails.data.product_sale.original_price - productDetails.data.product_sale.discount_price) * 100) / productDetails.data.product_sale.original_price).toFixed(2)}% off)</p> : parseInt(productDetails.data.product.discount_price) == 0 ? '' : <p className="discount-price"><span><Currency data={productDetails.data.product.original_price} /> </span>({Math.round(((productDetails.data.product.original_price - productDetails.data.product.discount_price) * 100) / productDetails.data.product.original_price).toFixed(2)}% off)</p>}

                                          </div>
                                          {productDetails.data.product.rating > 0 && (
                                             <div
                                                onClick={handleScrollToRatingBlock}
                                                className="rating-new pdp-rating-summary"
                                                role="button"
                                                tabIndex="0"
                                                onKeyDown={(event) => {
                                                   if (event.key === 'Enter' || event.key === ' ') {
                                                      event.preventDefault();
                                                      handleScrollToRatingBlock();
                                                   }
                                                }}
                                             >
                                                <span className="star" aria-hidden="true">★</span>
                                                <span className="rating">{productDetails.data.product.rating}</span>
                                                <span className="count">({Number(productDetails.data.ratings?.total_rating_count ?? productRating.data?.length ?? 0).toLocaleString()})</span>
                                             </div>
                                          )}
                                       </div>

                                       {productDetails.data && productDetails.data.product.sample ?
                                          <div className="sample-product">
                                             <p>{strings.sample_text_instruction}</p>
                                             <div className="sample-order-info">
                                                <div className="sample-info-left">
                                                <h4>
                                                   {productDetails.data.product.sample.size} ML
                                                   <span>&nbsp;({current_currency.country_code} {(parseFloat(current_currency.currency) * productDetails.data.product.sample.price).toFixed(2)})</span>
                                                </h4>
                                                </div>
                                                <div className="sample-info-right">
                                                {!sampleOrdered && <button onClick={() => orderSample(productDetails.data.product.sample.id)}>{strings.orderSample}</button>}
                                                </div>
                                             </div>
                                          </div> : ''}

                                       {hasSale && countdownTarget && (
                                          <div className="big-sale-banner">
                                             <div className="sale-left">🔥 Big Sale</div>

                                             <div className="sale-timer">
                                                Ends in {days > 0 ? `${days}d ` : ''}
                                                {hours < 10 ? `0${hours}` : hours}:
                                                {minutes < 10 ? `0${minutes}` : minutes}:
                                                {seconds < 10 ? `0${seconds}` : seconds}
                                             </div>
                                          </div>
                                       )}

                                       {productDetails.data && (productDetails.data.product.sold > 0 || productDetails.data.product.left > 0) && (
                                          <div className="stock-strip">
                                             <div className="stock-strip-top">
                                                {productDetails.data.product.sold > 0 && (
                                                   <span className="stock-sold">🚀 {productDetails.data.product.sold} {strings.sold}</span>
                                                )}
                                                {productDetails.data.product.left > 0 && (
                                                   <span className="stock-left">{strings.only ? strings.only + ' ' : ''}{productDetails.data.product.left} {strings.left}</span>
                                                )}
                                             </div>
                                             {(productDetails.data.product.sold + productDetails.data.product.left) > 0 && (
                                                <div className="stock-bar">
                                                   <span style={{ width: Math.max(6, Math.min(100, Math.round((productDetails.data.product.sold * 100) / (productDetails.data.product.sold + productDetails.data.product.left)))) + '%' }}></span>
                                                </div>
                                             )}
                                          </div>
                                       )}

                                       {productDetails.data ?
                                          productDetails.data.attributes.length > 0 ?
                                             productDetails.data.attributes.map((attribute, i) =>
                                                <div className="prd-size" key={i}>
                                                   <h4>{attribute.name}</h4>
                                                   <div className="prd_size_label">
                                                      {attribute.attribute_values.length > 0 ?
                                                         attribute.attribute_values.map((attr_val, i1) =>
                                                            <label className="custom_radio_b" key={i1}>
                                                               <input
                                                                  type="radio"
                                                                  name={attribute.id}
                                                                  value={attr_val.id}
                                                                  checked={attr ? attr.split(",").includes(attr_val.id.toString()) : ''}
                                                                  onClick={(e) => chnageattributeValue(e, i)}
                                                               />
                                                               {productDetails.data ?
                                                                  (attr_val.left === 0) ? (
                                                                     <del><span className="checkmark">{attr_val.value}</span></del>
                                                                  ) : (
                                                                     (productDetails.data.product.attribute_value_id === attr_val.id) && (productDetails.data.product.status === 0) ? (
                                                                        <del><span className="checkmark">{attr_val.value}</span></del>
                                                                     ) : (
                                                                        <span className="checkmark">{attr_val.value}</span>
                                                                     )
                                                                  )
                                                                  : null}
                                                            </label>
                                                         ) : ''}
                                                   </div>
                                                </div>
                                             ) : '' : ""}

                                       {selectedProductImages.length > 0 && (
                                       <div className="prd-size mb-2">
                                          <h4>{strings.color}</h4>
                                             <OwlCarousel
                                             className='owl-theme variant-carousel'
                                             loop={false}
                                             margin={10}
                                             nav
                                             items={5}
                                             >
                                             {selectedProductImages.map((image, imgIdx) => (
                                                <div 
                                                   key={imgIdx} 
                                                   className={`rounded-image ${selectedVariant.imgIdx === imgIdx ? 'selected-image' : ''}`}
                                                   onClick={() => {
                                                   handleSelectVariantImage(selectedAttrValueId, imgIdx, image.id, image.image);
                                                   }}
                                                >
                                                   <img key={imgIdx} src={image.image} alt={image.id} />
                                                </div>
                                             ))}
                                             </OwlCarousel>
                                       </div>
                                       )}

                                       <div id="field1" className="quantity_sec">
                                          <h4>{strings.qty}</h4>
                                          <div className="q_btn_group">
                                             <button type="button" id="sub" className="sub" onClick={(e) => addRemove(e, 'sub')}>-</button>
                                             <input type="number" id="1" value={comman.qty} min="1" max="3" />
                                             <button type="button" id="add" className="add" onClick={(e) => addRemove(e, 'add')}>+</button>
                                          </div>
                                       </div>
                                       
                                       <div className="add-btn-grp d-flex mt-3">

                                          {productDetails.data ? productDetails.data.cart_item == 0 ?

                                             productDetails.data.product.out_of_stock == 1 || productDetails.data.product.status == 0 ?
                                                <Button type="button" className="btn btn_primary me-2" disabled>{strings.out_of_stock}</Button>
                                                :
                                                productDetails.data.product.sold_out == 1 ?
                                                   <Button type="button" className="btn btn_primary me-2" disabled>{strings.sold_out}</Button>
                                                   :
                                                   productDetails.data.product.discontinue == 1 ?
                                                      <Button type="button" className="btn btn_primary me-2" disabled>{strings.discontinue}</Button> :
                                                      productDetails.data.product.left <= 0 ?
                                                         <Button type="button" className="btn btn_primary me-2" disabled>{strings.out_of_stock}</Button> :
                                                         comman.addCart ?
                                                            <Link to="/cart" className="btn btn_primary me-2">{strings.go_to_cart} </Link>
                                                            :
                                                            <Button type="button" onClick={() => { triggerFlyToCart(); addtoCart('addCart'); }} className="btn btn_primary me-2">{strings.add_to_bag}</Button>



                                             :
                                             productDetails.data.product.out_of_stock == 1 || productDetails.data.product.status == 0 ?
                                                <Button type="button" className="btn btn_primary me-2" disabled>{strings.out_of_stock}</Button>
                                                :
                                                productDetails.data.product.sold_out == 1 ?
                                                   <Button type="button" className="btn btn_primary me-2" disabled>{strings.sold_out}</Button>
                                                   :
                                                   productDetails.data.product.discontinue == 1 ?
                                                      <Button type="button" className="btn btn_primary me-2" disabled>{strings.discontinue}</Button>
                                                      :
                                                      productDetails.data.product.left <= 0 ?
                                                         <Button type="button" className="btn btn_primary me-2" disabled>{strings.out_of_stock}</Button> :
                                                         <Button className="btn btn_primary me-2" onClick={() => addtoCart('BuyNow')} >{strings.go_to_cart}</Button> : null}
                                          {/* <Link to="/cart" className="btn btn_primary me-2">Go To Cart </Link> : null} */}


                                          {productDetails.data && productDetails.data.product.out_of_stock == 1 || productDetails.data.product.status == 0 ?
                                             <Button type="button" className="btn btn_primary notify_btn me-2" onClick={(e) => showModalNotifyMe(e)}>{strings.notifyMe}</Button>
                                             :
                                             productDetails.data.product.sold_out == 1 ?
                                                <Button type="button" className="btn btn_primary notify_btn me-2" onClick={(e) => showModalNotifyMe(e)} >{strings.notifyMe}</Button>
                                                :
                                                productDetails.data.product.discontinue == 1 ?
                                                   <Button type="button" className="btn btn_primary notify_btn me-2" onClick={(e) => showModalNotifyMe(e)}>{strings.notifyMe}</Button>
                                                   :
                                                   productDetails.data.product.left <= 0 ?
                                                      <Button type="button" className="btn btn_primary notify_btn me-2" onClick={(e) => showModalNotifyMe(e)}>{strings.notifyMe}</Button> :
                                                      <Button href="#" onClick={() => addtoCart('BuyNow')} className="btn btn_primary">{strings.buyNow}</Button>}
                                       </div>
                                       <div></div>
                                       {/* Taly "Split into 4 payments" widget — price in KWD (Taly base currency) × qty */}
                                       {(() => {
                                          const talyBase = productDetails.data.product_sale
                                             ? (productDetails.data.product_sale.discount_price != 0 ? productDetails.data.product_sale.discount_price : productDetails.data.product_sale.original_price)
                                             : (productDetails.data.product.discount_price != 0 ? productDetails.data.product.discount_price : productDetails.data.product.original_price);
                                          const talyTotal = parseFloat(talyBase) * (comman.qty || 1);
                                          return talyTotal > 0 ? (
                                             <div style={{ marginTop: '10px' }}>
                                                <BnplWidget price={talyTotal} paymentPage="product" />
                                             </div>
                                          ) : null;
                                       })()}
                                    </div>
                                 </div>
                                 {(productDetails.data.notes_color.length > 0 ||
                                       productDetails.data.base_accord.length > 0 || 
                                       productDetails.data.middle_accord.length > 0 || 
                                       productDetails.data.top_accord.length > 0) && (
                                          <div className="main-prd-right" style={{ display: 'flex', gap: '20px' }}>
                                             {/* Cột 1: Perfume Accords */}
                                             {productDetails.data.notes_color.length > 0 && (
                                                <div className="column column-left" style={{ flex: 1 }}>
                                                   <div className="perfume-acords">
                                                      <h4>{strings.perfume_accords}</h4>
                                                   </div>
                                                   <div className="progress-wrap">
                                                      {productDetails.data.notes_color.map((item, index) => (
                                                         <div 
                                                            className="woody-bg" 
                                                            key={index} 
                                                            style={{ background: item.color, width: 100 - (8 * index) + '%' }}
                                                         >
                                                            <span style={{ color: '#000' }}>{item.name}</span>
                                                         </div>
                                                      ))}
                                                   </div>
                                                </div>
                                             )}

                                             {/* Cột 2: Notes Accord */}
                                             {(productDetails.data.base_accord.length > 0 || 
                                             productDetails.data.middle_accord.length > 0 || 
                                             productDetails.data.top_accord.length > 0) && (
                                                <div className="column column-right" style={{ flex: 1 }}>
                                                   {productDetails.data.top_accord.length > 0 && (
                                                      <div className="notes-section">
                                                         <h4 className="notes-title">{strings.top_notes}</h4>
                                                         <div className="notes-images">
                                                            {productDetails.data.top_accord.map((note, index) => (
                                                               <div className="note-item" key={`top-${index}`} style={{ textAlign: 'center' }}>
                                                                  <img 
                                                                     src={note.image} 
                                                                     alt={note.name}
                                                                  />
                                                                  <p>{note.name}</p>
                                                               </div>
                                                            ))}
                                                         </div>
                                                      </div>
                                                   )}
                                                   {productDetails.data.middle_accord.length > 0 && (
                                                      <div className="notes-section">
                                                         <h4 className="notes-title">{strings.middle_notes}</h4>
                                                         <div className="notes-images">
                                                            {productDetails.data.middle_accord.map((note, index) => (
                                                               <div className="note-item" key={`middle-${index}`} style={{ textAlign: 'center' }}>
                                                                  <img 
                                                                     src={note.image} 
                                                                     alt={note.name}
                                                                  />
                                                                  <p>{note.name}</p>
                                                               </div>
                                                            ))}
                                                         </div>
                                                      </div>
                                                   )}
                                                   {productDetails.data.base_accord.length > 0 && (
                                                      <div className="notes-section">
                                                         <h4 className="notes-title">{strings.base_notes}</h4>
                                                         <div className="notes-images">
                                                            {productDetails.data.base_accord.map((note, index) => (
                                                               <div className="note-item" key={`base-${index}`} style={{ textAlign: 'center' }}>
                                                                  <img 
                                                                     src={note.image} 
                                                                     alt={note.name}
                                                                  />
                                                                  <p>{note.name}</p>
                                                               </div>
                                                            ))}
                                                         </div>
                                                      </div>
                                                   )}
                                                </div>
                                             )}
                                          </div>
                                       )}
                                 <div className="prd-info pdp-productinfo">
                                    <div className="prd-info-cont">
                                       <h5>{strings.product_information}</h5>
                                       <ul>
                                          <li><span>{strings.SKU} :</span><span className="right-cont">{productDetails.data.product.sku}</span></li>
                                          {productDetails.data.product.barcode != 0 ? <li><span>{strings.barcode} :</span><span className="right-cont">{productDetails.data.product.barcode}</span></li> : null}
                                          <li><span>{strings.brand} :</span><span className="right-cont">{productDetails.data.product.brands != null ? productDetails.data.product.brands.name : ''}</span></li>
                                          <li><span>{strings.perfume_for} : </span><span className="right-cont">{productDetails.data.product.categories.name}</span></li>
                                          <li><span>{strings.perfume_type} :</span><span className="right-cont">{productDetails.data.product.perfume_type ? productDetails.data.product.perfume_type.name : ''}</span></li>
                                       </ul>
                                    </div>
                                 </div>
                                 <div className='prd-dtl-bottom-cont'>
                                    <div className="pdp-freeship">
                                       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="1" y="4" width="14" height="12" rx="1.5"/><path d="M15 8h4l4 4v4h-8V8z"/><circle cx="6" cy="18.5" r="2"/><circle cx="18" cy="18.5" r="2"/></svg>
                                       <span>{strings.freeShippingThreshold || 'Free Shipping on orders above KWD 15'}</span>
                                    </div>
                                    <div className="pdp-trust-badges">
                                       <div className="pdp-tb">
                                          <span className="pdp-tb-ic"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polygon points="12 2 15 8.5 22 9.3 17 14 18.2 21 12 17.6 5.8 21 7 14 2 9.3 9 8.5 12 2"/></svg></span>
                                          <span>{strings.highRatedSeller || 'High Rated Seller'}</span>
                                       </div>
                                       <div className="pdp-tb">
                                          <span className="pdp-tb-ic"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="1 4 1 10 7 10"/><path d="M3.5 15a9 9 0 1 0 2.1-9.4L1 10"/></svg></span>
                                          <span>{strings.lowReturns || 'Low Returns'}</span>
                                       </div>
                                       <div className="pdp-tb">
                                          <span className="pdp-tb-ic"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg></span>
                                          <span>{strings.secureTransaction || 'Secure Transaction'}</span>
                                       </div>
                                    </div>
                                    <div className="pdp-delivery">
                                       <div className="pdp-delivery-title">{strings.delivery_information || 'Delivery Information'}</div>
                                       <div className="pdp-delivery-card">
                                          <div className="pdp-delivery-left">
                                             <span className="express-badge">express</span>
                                             <span className="pdp-delivery-text">{strings.get_it_by || 'Get it by'} <b>{(() => { const t = new Date(); const a = new Date(t); a.setDate(t.getDate() + 1); const b = new Date(t); b.setDate(t.getDate() + 2); const f = (d) => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); return f(a) + ' – ' + f(b); })()}</b></span>
                                          </div>
                                          <span className="pdp-delivery-cut">{(() => { const n = new Date(); const c = new Date(n); c.setHours(16, 30, 0, 0); if (c <= n) c.setDate(c.getDate() + 1); const d = c - n; const h = Math.floor(d / 3600000); const m = Math.floor((d % 3600000) / 60000); return (strings.order_in || 'Order in') + ' ' + h + 'h ' + m + 'm'; })()}</span>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </section>
                  {productDetails.data ? productDetails.data.notes_image.length > 0 ?
                     <section className="space-cls prd-perfume-sec">
                        <div className="container">
                           <div className="perfume_inner_title">
                              <h3>{strings.perfume_notes}</h3>
                              <div className="show-votes">
                                 <div className="address-toggle">
                                    {/*<span>Show Notes</span>*/}
                                    {/* <Toggle
                           label="Toggle me"
                           toggled={true}
                           onClick={logState}
                        /> */}

                                 </div>
                              </div>
                           </div>
                           <div className="row">
                              {
                                 productDetails.data.notes_image.map((item, index) =>
                                    <div className="col-md-2">
                                       <div className="prd-perfume-box">
                                          <div className="prd-perfume-img">
                                             <img src={item.image} alt={item.name} />
                                          </div>
                                          <h4>{item.name}</h4>
                                       </div>
                                    </div>
                                 )}
                           </div>
                        </div>
                     </section> : null : null}
                  {productDetails.data ? productDetails.data.product.rating > 0 ?
                     <section className="space-cls rating-main-sec">
                        <div className="container">
                           <div id="perfumeBlockFirst" className="perfume_inner_title">
                              <h4>{strings.ratings}</h4>
                           </div>
                           <div className="rating-sec">
                              <div className="rating-left">
                                 <div>
                                    <span className="rating_title">{productDetails.data ? productDetails.data.product ? productDetails.data.product.rating : 0 : 0}</span>
                                    <span className="rating-ic">
                                       <img src={ImgmStar1} alt='Star' />
                                    </span>
                                 </div>
                                 <h6>{productDetails.data.ratings.total_rating_count} {strings.verifiedBuyer}</h6>
                              </div>
                              {productDetails.data ? productDetails.data.ratings ? productDetails.data.ratings.total_rating_count > 0 ?
                                 <div className='rating-right'>
                                    <div className="App">
                                       <div className='rating-percent'>
                                          <span className="rating-no">5 <img alt='Star' src={ImgmStar1} /></span>
                                          <div className='rating-progress'>
                                             <ProgressBar bgcolor={"6a1b9a"} completed={productDetails.data ? productDetails.data.ratings ? ((productDetails.data.ratings.five * 100) / productDetails.data.ratings.total_rating_count) : 0 : 0} />
                                          </div>
                                          <div className='rating-number'>{productDetails.data.ratings.five}</div>
                                       </div>
                                       <div className='rating-percent'>
                                          <span className="rating-no">4 <img alt='Star' src={ImgmStar1} /></span>
                                          <div className='rating-progress'>
                                             <ProgressBar completed={productDetails.data ? productDetails.data.ratings ? ((productDetails.data.ratings.four * 100) / productDetails.data.ratings.total_rating_count) : 0 : 0} />
                                          </div>
                                          <div className='rating-number'>{productDetails.data.ratings.four}</div>
                                       </div>
                                       <div className='rating-percent'>
                                          <span className="rating-no">3 <img alt='Star' src={ImgmStar1} /></span>
                                          <div className='rating-progress'>
                                             <ProgressBar completed={productDetails.data ? productDetails.data.ratings ? ((productDetails.data.ratings.three * 100) / productDetails.data.ratings.total_rating_count) : 0 : 0} />
                                          </div>
                                          <div className='rating-number'>{productDetails.data.ratings.three}</div>
                                       </div>
                                       <div className='rating-percent'>
                                          <span className="rating-no">2 <img alt='Star' src={ImgmStar1} /></span>
                                          <div className='rating-progress'>
                                             <ProgressBar completed={productDetails.data ? productDetails.data.ratings ? ((productDetails.data.ratings.two * 100) / productDetails.data.ratings.total_rating_count) : 0 : 0} />
                                          </div>
                                          <div className='rating-number'>{productDetails.data.ratings.two}</div>
                                       </div>
                                       <div className='rating-percent'>
                                          <span className="rating-no">1 <img alt='Star' src={ImgmStar1} /></span>
                                          <div className='rating-progress'>
                                             <ProgressBar completed={productDetails.data ? productDetails.data.ratings ? ((productDetails.data.ratings.one * 100) / productDetails.data.ratings.total_rating_count) : 0 : 0} />
                                          </div>
                                          <div className='rating-number'>{productDetails.data.ratings.one}</div>
                                       </div>
                                    </div>
                                 </div>
                                 : null : 0 : 0}
                              {/* <div className="rating-right">
                              <div className="rating-percents">
                                 <div className="rating-percent">
                                    <span className="rating-no">5 <img src={ImgmStar} /></span>
                                    <div className="rating-progress"></div>
                                 </div>
                                 <div className="rating-percent">
                                    <span className="rating-no">4 <img src={ImgmStar} /></span>
                                    <div className="rating-progress"></div>

                                 </div>
                                 <div className="rating-percent">
                                    <span className="rating-no">3 <img src={ImgmStar} /></span>
                                    <div className="rating-progress"></div>

                                 </div>
                                 <div className="rating-percent">
                                    <span className="rating-no">2 <img src={ImgmStar} /></span>
                                    <div className="rating-progress"></div>
                                 </div>
                                 <div className="rating-percent">
                                    <span className="rating-no">1 <img src={ImgmStar} /></span>
                                    <div className="rating-progress"></div>
                                 </div>
                              </div>
                           </div> */}
                           </div>
                        </div>
                     </section>
                     : null : null}
                  {productRating.data ? productRating.data.length > 0 ?
                     <section className="space-cls customer-review_sec">
                        <div className="container">
                           <div className="perfume_inner_title">
                              <h4>{strings.customerPhotos} ({productRating ? productRating.data ? productRating.data.length > 0 ? productRating.data.filter(item => !item.image.includes('images/noimage.png')).length : 0 : 0 : 0})</h4>
                           </div>
                           <div className="reivew-inner-list review-image-list">
                              {productRating.data.map((item, index) =>
                                 <div className="review-image">
                                    {!item.image.includes('images/noimage.png') ? <img alt={item.name} src={item.image} className="img-fluid rating_image_detail" alt="..."></img> : ''}
                                 </div>
                              )
                              }
                           </div>
                        </div>
                     </section>
                     : null : null}
                  {productRating.data ? productRating.data.length > 0 ?
                     <section className="space-cls customer-review_sec">
                        <div className="container">
                           <div className="perfume_inner_title">
                              <h4>{strings.customers_reviews} ({productRating ? productRating.data ? productRating.data.length > 0 ? productRating.data.length : 0 : 0 : 0})</h4>
                           </div>
                           <div className="reivew-inner-list">
                              {productRating.data ?
                                 productRating.data.map((item, index) =>
                                    <div className="review-inner">
                                       <div className="reviiew-dtl">
                                          <div className="review-left">
                                             <span className="review-dtl-bg">{item.rating} <span><img src={ImgmStar} alt='Star' /></span></span>
                                          </div>
                                          <div className="review-right">
                                             <p>{item.review}.</p>
                                             {!item.image.includes('images/noimage.png') ? <img src={item.image} className="img-fluid rating_image_detail" alt={item.name}></img> : ''}
                                             <span>{item ? item.users ? item.users.name : '' : ''} | {item ? moment(item.updated_at).format('DD-MMMM-YYYY') : ''}  </span>
                                          </div>
                                       </div>
                                       <div className="likeBlock">
                                          <div className='like' onClick={(e) => likeReview(item.id, 'like')}>
                                             <i className="far fa-thumbs-up"></i>
                                             <span>{item.likes.length}</span>
                                          </div>
                                          <div className='dislike' onClick={(e) => likeReview(item.id, 'dislike')}>
                                             <i className="far fa-thumbs-down"></i>
                                             <span>{item.dislikes.length}</span>
                                          </div>
                                       </div>
                                    </div>) : <section className="space-cls no_image review_noImg">
                                    <div className="container">
                                       <div className="cart_row">
                                          <div className='col-md-12'>
                                             <h3>
                                                <center>
                                                   <img src={noReview} alt="Out of Stock" />
                                                </center>
                                             </h3>
                                          </div>
                                       </div>
                                    </div>
                                 </section>}

                           </div>
                        </div>
                     </section>
                     : null : null}
               </>
               : <Skeleton height={50} count={20} />}

            {productDetails.data ? productDetails.data.related_brand_product ? productDetails.data.related_brand_product.length > 0 ?
               <section className="space-cls home-fragrance-prd-sec">
                  <div className="container">
                     <div className="title-main">
                        <h2 className="heading-type1">{strings.releatedProduct}</h2>
                        {/* {commanData.data && commanData.data.most_sold != '' ? <h2 className="heading-type1">{strings.mostPickedProduct}</h2> : ''} */}
                     </div>
                     {productDetails.data ? <Product showAddtoCart={showAddtoCart} data={productDetails.data.related_brand_product} options={newAriveOption} /> : <Skeleton height={50} count={20} />}

                  </div>
               </section>
               : null : null : null}

            <CommanList />
         </main>
         <Footer />
         {modalIsOpen ? <>
				<Modal id="selectionModal" show={true} animation={true} size="lg" backdrop="static" keyboard={false} centered>
					<Modal.Header className="modal-header-custom">
						{/* <h5 className="modal-title">{strings.pickItemSize}</h5> */}
						<button
						type="button"
						className="btn-close"
						aria-label="Close"
						onClick={setModalIsOpenToFalse}
						>
						<img src={Imgcross} alt="Close" />
						</button>
					</Modal.Header>
					<Modal.Body className="modal-body-custom">
						<ValidationForm ref={formRef}>
						<div className="product-details">
							<img src={commanList.product.image} alt={commanList.product.name} className="product-image" />
							<div className="product-info">
								<h6 className="product-name">{commanList.product.name}</h6>
								{/* Size Options */}
								<Form.Group className="form-group prd-size-group" controlId="form-group">
									<div className="prd_size_label">
									{commanList.attributes[0]?.attribute_values &&
										commanList.attributes[0].attribute_values.map((option, i) => (
										<label className="custom_radio_b" key={option.id}>
											<input
											type="radio"
											name="attribute_value_id"
											value={option.id}
											defaultChecked={i === 0}
                                 onChange={(e) => handleAttributeChange(commanList.product.id, option.id)}
											/>
											<span className="checkmark">{option.value}</span>
										</label>
										))}
									</div>
								</Form.Group>
							</div>
							<div className="product-price">
								<Currency data={commanList.product.discount_price != 0 ? commanList.product.discount_price : commanList.product.original_price} />
							</div>
						</div>

						{/* Submit Button */}
						<div className="login-btn">
							<Button
							onClick={(e) => addtoCart(commanList.product_id, 'form')}
							type="button"
							className="btn btn-primary w-100"
							>
							{strings.pickThisSize}
							</Button>
						</div>
						</ValidationForm>
					</Modal.Body>
				</Modal></> : ""}
         {modalNotifyMeIsOpen ? <>
            <Modal show={true} animation={true} size="lg" backdrop="static" keyboard={false} centered >
               <Modal.Header>
                  <h5 className="modal-title" id="exampleModalLabe112l">{strings.notifyMe}</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                     <img src={Imgcross} alt='Close' onClick={setModalNotifyMeIsOpenToFalse()} />
                  </button>
               </Modal.Header>
               <Modal.Body className='modal-body'>
                  <div className="continue-btn review_modal notify_me_modal">
                     <ValidationForm ref={formRef2} >
                        <div className="popup-cont">
                           <Form.Group className="form-group" controlId="form-group">
                              <Form.Label>{strings.name}</Form.Label>
                              <TextInput name="name" id="name" placeholder={strings.plz_enter_name} required onChange={(e) => setNameReview(e.target.value)} />
                           </Form.Group>
                           <Form.Group className="form-group" controlId="form-group">
                              <Form.Label>{strings.phoneNumber}</Form.Label>
                              <TextInput name="phone" id="phone" placeholder={strings.plz_enter_phone} required onChange={(e) => setPhoneReview(e.target.value)} />
                           </Form.Group>
                           <div className="login-btn">
                              <Button onClick={(e) => notifyMe()} type="button" className="btn btn_primary">{strings.notifyMe}</Button>
                           </div>
                        </div>
                     </ValidationForm>
                  </div>
               </Modal.Body>
            </Modal></> : ""}
         {flyItem && (
            <div key={flyItem.key} className="fly-to-cart-item" style={flyItem.style}>
               <img src={flyItem.src} alt="" />
            </div>
         )}
      </>
   )
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
